<div>
  <h3 class="form-field-title">{{ props.label }}</h3>
  <div class="field-container">
    <ng-container #fieldComponent></ng-container>
    <span *ngIf="props?.description">
      <mat-hint *ngIf="isHtml" [innerHtml]="props.description"></mat-hint>
      <mat-hint *ngIf="!isHtml" [innerText]="props.description"></mat-hint>
    </span>
  </div>
</div>